import { render, staticRenderFns } from "./classServiceTow.vue?vue&type=template&id=9aeb71b2&scoped=true&"
import script from "./classServiceTow.vue?vue&type=script&lang=ts&"
export * from "./classServiceTow.vue?vue&type=script&lang=ts&"
import style0 from "./classServiceTow.vue?vue&type=style&index=0&id=9aeb71b2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9aeb71b2",
  null
  
)

export default component.exports